export default "__VITE_ASSET__Dm58g2vM__"